// Profile of Alina Tselinina, Dutch. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina is software engineer met een achtergrond in data-engineering, toegepaste wiskunde en machine learning en werkt nu aan AI-gestuurde applicaties en agentische systemen. Zij heeft ervaring met het bouwen van API’s en datapijplijnen, het moderniseren van applicaties via cloudmigratie en het ontwikkelen van ML-gestuurde diensten. Haar focus ligt op het verbinden van LLM’s en AI-agenten met betrouwbare softwaresystemen via gestructureerde workflows, integraties, testen en iteratieve evaluatie.',
  imageAlt: 'Portret van Alina Tselinina',
  personal: {
    languages: 'Engels, Pools',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Studie: financiële en actuariële wiskunde',
      institution: 'Adam Mickiewicz-universiteit, Poznań',
      degree: 'Diploma: master'
    },
    {
      period: '2009 - 2014',
      field: 'Studie: wiskunde',
      institution: 'Wit-Russische Staatsuniversiteit, Minsk',
      degree: 'Diploma: bachelor'
    }
  ],
  skills: [
    {
      title: 'Programmeren',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'AI en LLM’s',
      description: 'Claude, MCP, AI-agenten, LLM-aanpassing, modeltraining en evaluatie'
    },
    {
      title: 'Cloud en data',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Frameworks en API’s',
      description: 'FastAPI, Flask, Shiny, REST-API’s, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Data-engineering en DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Databases en orkestratie',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Atlassian-tools',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'maart 2026 - heden',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'AI-agentontwikkeling, configuratie van workflows en integratie van tools.',
        'Aanpassing van LLM’s, modeltraining en evaluatie.',
        'Ontwikkeling en integratie van AI-gestuurde applicaties.',
        'Quantumcomputing: bijdragen aan softwareontwikkeling voor quantumtoepassingen.'
      ]
    },
    {
      period: 'mei 2025 - heden',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'App-ontwikkeling.',
        'Implementatie van unit- en UI-tests ter ondersteuning van de applicatiekwaliteit.'
      ]
    },
    {
      period: 'november 2022 - februari 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Onderhoud en verbetering van datapijplijnen en workflow-orkestratie.',
        'Ontwikkeling van pakketten voor rapportageautomatisering.'
      ]
    },
    {
      period: 'juli 2022 - oktober 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Ontwikkeling en onderhoud van ETL-pijplijnen.'
      ]
    },
    {
      period: 'maart 2022 - juni 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Ontwerp en ontwikkeling van REST-API’s en backenddiensten.',
        'Implementatie van de backendlogica voor JSON-verwerking.'
      ]
    },
    {
      period: 'november 2020 - maart 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Ontwerp en ontwikkeling van REST-API’s en backenddiensten (proof of concept).',
        'Ontwikkeling en onderhoud van ETL-pijplijnen.',
        'Modernisering van on-premise applicaties via AWS-migratie en het herschrijven van R-code in Python.',
        'XML-validatie en transformatie naar HTML.',
        'Ontwikkeling van webapplicaties.'
      ]
    },
    {
      period: 'mei 2020 - november 2020',
      title: 'Data Scientist, PSI Polska, Poznań',
      description: [
        'Ontwerp en ontwikkeling van REST-API’s en backenddiensten met een machine-learningmodel in de backend.',
        'Ontwikkeling van een klantsegmentatiemodel.'
      ]
    },
    {
      period: 'januari 2019 - april 2020',
      title: 'Advanced Data Scientist, Analyx, Poznań',
      description: [
        'Web scraping en ontwikkeling van datapipelines.',
        'Ontwikkeling van webapplicaties.',
        'Marketingmixmodellering.',
        'Optimalisatie van werkprocessen.'
      ]
    },
    {
      period: 'mei 2018 - december 2018',
      title: 'Data Scientist, Poznań',
      description: [
        'Ontwikkeling van een ETL-proces.',
        'Onderhoud van Bash-scripts.',
        'Klantondersteuning en ad-hocanalyses.'
      ]
    },
    {
      period: 'april 2017 - april 2018',
      title: 'Junior Analyst, Poznań',
      description: [
        'Data-analyse en het maken van rapporten.',
        'Opstellen van documentatie en presentaties.'
      ]
    }
  ]
};
